import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { UserEvent } from '../../api/userEvents/interface';
import type { StoreState } from '../store';
import { actions as userEventsSliceActions } from './logic';

export interface UseUserEventHookState {
  actions: StoreState['userEvents']['actions'];
}

export interface UseUserEventHookHandler {
  addUserEvent(userEventData: UserEvent): void;
}

const useUserEventHook = (): [
  UseUserEventHookState,
  UseUserEventHookHandler
] => {
  const dispatch = useDispatch();
  const { actions } = useSelector((s: StoreState) => s['userEvents']);
  const handler = React.useMemo(
    () => ({
      addUserEvent: (userEventData: UserEvent) => {
        dispatch(userEventsSliceActions.addUserEvent(userEventData));
      },
    }),
    []
  );
  return [{ actions }, handler];
};

export default useUserEventHook;
